import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import { dataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';

const AddNewInstitutionDialog = ({ isWizardStep }) => {
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();

  const {
    resource, onSubmit,
  } = useMetaLayoutContext();

  const {
    handleClose,
  } = useConfirmationDialogState({});

  const loadModal = async (url) => {
    await loadModalCollectionByLink(url);
  };

  const handleManualAccount = async () => {
    if (isWizardStep) {
      await onSubmit();
      return;
    }

    resource.withRelationship(
      fr.relationships.addManualAccount.name,
      (rel) => {
        return loadModal(rel.link('related').url());
      }, () => null,
    );
  };

  const handleLinkAccount = () => resource.withRelationship(
    fr.relationships.linkAccount.name,
    (rel) => loadModal(rel.link('related').url()),
    () => null,
  );

  return (
    <NewDialog
      title={resource.attr('title')}
      message={resource.attr('subtitle')}
      cancelLabel={'Add manually'}
      confirmLabel={'Connect an account'}
      confirmButtonType="info"
      showCloseIcon
      onConfirm={handleLinkAccount}
      onCancel={handleManualAccount}
      onClose={() => {
        handleClose();
        clearModalCollection();
      }}
      {...dataAttrs('add-institution-modal')}
      maxWidth={'sm'}
    />
  );
};

AddNewInstitutionDialog.propTypes = {
  isWizardStep: PropTypes.bool.isRequired,
};

AddNewInstitutionDialog.defaultProps = {
};

export default AddNewInstitutionDialog;
